import script from "./ConfirmDialogue.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDialogue.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDialogue.vue?vue&type=style&index=0&id=78754dd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78754dd4"]])

export default __exports__